module.exports = __webpack_public_path__ + "assets/img/specialistInformationimg.e0aadd10.png";